export const RESET_PHONE_VERIFICAITON_MOBILE_ID_SUCCESS =
  'RESET_PHONE_VERIFICAITON_MOBILE_ID_SUCCESS' as const

export const resetPhoneVerificationMobileIdSuccessAction = () => ({
  type: RESET_PHONE_VERIFICAITON_MOBILE_ID_SUCCESS,
})
